document.addEventListener('DOMContentLoaded', function() {
    // Zoek alle FAQ-expanded accordions (met verschillende block_id's)
    const accordions = document.querySelectorAll('[id^="faq-accordion-expanded-"]');

    accordions.forEach(accordion => {
        const accordionButtons = accordion.querySelectorAll('[data-toggle="collapse"]');

        accordionButtons.forEach(button => {
            button.addEventListener('click', function() {
                const mediaTarget = this.getAttribute('data-media-target');

                // Vind de bijbehorende media container voor dit specifieke blok
                const mediaContainer = accordion.closest('.row').querySelector('[id^="faq-media-container-"]');

                if (mediaContainer) {
                    // Verberg alleen media items binnen dit specifieke blok
                    mediaContainer.querySelectorAll('.faq-media-item').forEach(item => {
                        item.style.display = 'none';
                    });

                    // Toon het juiste media item
                    const targetMedia = document.getElementById(mediaTarget);
                    if (targetMedia) {
                        targetMedia.style.display = 'block';
                    }
                }
            });
        });
    });
});
